<script lang="ts" setup>

//#region I M P O R T S
import { DxAutocomplete } from "devextreme-vue/autocomplete";
import { icons } from "@/helpers";
import Card from "@/components/containers/Navbar/formulariosMenu/formularioCards/CardMenu.vue";
import Panel from "@/components/panel/PanelWrapper.vue";
import type { CardProps } from "./types";
import IconProfiles from "@/assets/icons-svg/icon-profiles.svg";
import IconContainer from "@/assets/icons-svg/icon-container.svg";
import CardLoading from '@/components/containers/Navbar/formulariosMenu/formularioCards/CardLoading.vue'
import { Drawer, type DrawerProps } from "@/components";
import { computed, getCurrentInstance, ref, watch, onMounted, nextTick } from "vue";
import traducao from "@/localization/vistra.formularios.json";
import { DxButton} from 'devextreme-vue'
//#endregion

//#region I N I C I A L I Z A Ç Ã O

type Props = {
    show: boolean;
    usuario: object;
};

type EmitHandles = {
    onClose: () => void;
};

defineProps<Props>();
defineEmits<EmitHandles>();

//#endregion

// #region DATA AND REFS
const data = ref({
	dadosFormularios: [],
	dadosGrupos: [],
	carregandoFormularios: true,
});
const app = getCurrentInstance()
const { $http, $vistra } = app!.appContext.config.globalProperties
const card = ref<CardProps | null>(null);
const drawer = ref<DrawerProps>();
const formulariosContainer = ref();
const categoriesRef = ref();
const selected = ref(0);
const filtro = ref('');
const search = ref<string | null>(null);
const navegandoSideBar = ref(false);
const autocompleteRef = ref(null);
const isFocused = ref(false);
const drawerMobile = ref<DrawerProps>()
const margemTop = 104;
let optionsDropdownSearch = {
    width: $vistra.getDispositivo() != 'mobile' ? '500px' : '310',
    resizeEnabled: true
}
$vistra.carregaTraducao([traducao]);

// #endregion

//#region F I L T R O S
const filterByTerm = (dados): [] => {
  return dados.filter(p => {
        let encontrou = true;
        filtro.value.toLowerCase().match(/(["'])[^]*?\1|([^\s])+/g)?.forEach(element => {
            if ((!String(p.id).includes(element.toLowerCase())) &&
                (!p.nome.toLowerCase()
                    .replace(/[ÀÁÂÃÄÅ]/g,"A")
                    .replace(/[àáâãäå]/g,"a")
                    .replace(/[ÈÉÊË]/g,"E")
                    .replace(/[èéêë]/g,"e")
                    .replace(/[Ç]/g,"C")
                    .replace(/[ç]/g,"c")
                .includes(
                    element.toLowerCase()
                    .replace(/\"|\'/g, "")
                    .replace(/[ÀÁÂÃÄÅ]/g,"A")
                    .replace(/[àáâãäå]/g,"a")
                    .replace(/[ÈÉÊË]/g,"E")
                    .replace(/[èéêë]/g,"e")
                    .replace(/[Ç]/g,"C")
                    .replace(/[ç]/g,"c")))) {
                encontrou = false;
            }
        });
        return encontrou;
    })
}

const dsSearch = computed(() => {
    return data.value.dadosFormularios.map(p => ({label: p.nome, category: p.nomeGrupo}))
})

const filtered = (nomeGrupo) => {
  if(nomeGrupo?.toLowerCase() == 'recentes') {
      return recentesFiltrados.value
  }
    return data.value.dadosFormularios.filter((painel) => painel.nomeGrupo.toLowerCase() === nomeGrupo.toLowerCase());
};

const recentes = computed(() => {
    return $vistra.ordenarPor(data.value.dadosFormularios.filter(p => p.ultimoAcesso), "ultimoAcesso").reverse().slice(0, 3)
})

const recentesFiltrados = computed(() => {
    if (filtro.value)
        return filterByTerm(recentes.value);
    return recentes.value
})

const favoritosFiltrados = computed(() => {
    if (filtro.value)
        return filterByTerm(data.value.dadosFormularios.filter(p => p.favorito));
    return data.value.dadosFormularios.filter(p => p.favorito)
})

//#region RELATORIOS
const formulariosFiltrados = computed(() => {
    if (filtro.value)
        return filterByTerm(data.value.dadosFormularios);
    return data.value.dadosFormularios
})
let gruposFormulariosFiltradosSideBar = computed(() => {
    let retorno = [];
    if(!filtro.value)
        retorno = [{id: 0, nome: 'Destaques', icon: IconContainer, loading: true}]
    return retorno.concat(gruposFormulariosFiltrados.value?.filter(g => { 
        return formulariosFiltrados.value?.find(p => p?.idGrupo === g?.id);
    }));
})

let gruposFormulariosFiltrados = computed(() => {
  return data.value.dadosGrupos.filter(g => { 
    return formulariosFiltrados.value.find(p => p.idGrupo === g.id);
  })
})

//#endregion

let timeoutSearch: ReturnType<typeof setTimeout> = 0;
const onValueChanged = (e) => {
    if((e.event.type == 'keyup' && e.component._changedValue && e.component._changedValue.length < 2) &&
        (e.event.type == 'input' && (!e.value || e.value.length < 2)) &&
        (e.event.type == 'dxclick' && !e.value))
        return
        
    if(timeoutSearch)
        clearTimeout(timeoutSearch)
    if(e.event.type == 'keyup') {
        filtro.value = e.component._changedValue
    } else if(e.event.type == 'dxclick') {
        filtro.value = e.value
    }
    else if(e.event.type == 'input') {
        timeoutSearch = setTimeout(() => filtro.value = e.value, 2000)
    }
}
//#endregion

//#region R E N D E R I Z A Ç Ã O
const goToFormsMobile = () => {
  if(selected.value && $vistra.getDispositivo() == 'mobile'){
    //Se for selecionado um valor no mobile ele fecha e vai ate os paineis do grupo
    drawerMobile.value?.toggle()
  }
}

const goToCategory = (id, idx) => {
  selected.value = idx
  navegandoSideBar.value = true
  if(id == 'Destaques0') {
    formulariosContainer.value.scrollTo({
      top: 0
    })
    return;
  }
  formulariosContainer.value.scrollTo({
    top: (document.getElementById(id).offsetTop - margemTop)
  })
  goToFormsMobile();
}

const between = (x, min, max) => {
    return x >= min && x <= max;
}

let showFormulariosOnScroll = () => {
    if(!categoriesRef.value || !formulariosContainer.value)
        return
    
    let categoriaAtiva = false
    let categoryDestaque = document.getElementById('#Destaques0')
    categoriesRef.value?.forEach(element => {

        if( categoryDestaque && !navegandoSideBar.value && (formulariosContainer.value.scrollTop + 230) >= categoryDestaque.offsetTop && (formulariosContainer.value.scrollTop + 230) <= categoryDestaque.offsetTop + categoryDestaque.offsetHeight) {
            if(selected.value !== 0) {
                selected.value = 0;
                categoriaAtiva = true
            }
        }

        if(!categoriaAtiva && !navegandoSideBar.value && (formulariosContainer.value.scrollTop + 230) >= element.offsetTop && (formulariosContainer.value.scrollTop + 230) <= element.offsetTop + element.offsetHeight) {
            let idx = !filtro.value ? (+element.getAttribute('data-idx')) + 1 : (+element.getAttribute('data-idx'));

            if(selected.value !== idx) {
                selected.value = idx;
                categoriaAtiva = true
                let position = document.getElementById('lista-grupos')?.querySelectorAll('.sidebar-item')[idx]?.offsetTop - 200 //200 é uma margem pra não ficar bem no topo e pode ser mudada se achar necessário
                document.getElementById('lista-grupos')?.scrollTo({top: position})
            }
        }

        // carrega (se ainda não carregou) os paineis do grupo se este estiver na área visível da tela
        // ganha performance ao não carregar todos os paineis de todos os grupos ao mesmo tempo
        const areaVisivel = formulariosContainer.value.scrollTop + window.innerHeight
        if (between(element.offsetTop, formulariosContainer.value.scrollTop, areaVisivel) || between(element.offsetTop + element.offsetHeight, formulariosContainer.value.scrollTop, areaVisivel)) {
            let grupo = data.value.dadosFormularios.find(grupo => (grupo.nome + grupo.id) == element.id)
            if(grupo?.loading) {
                setTimeout(() => { //tempo pra fazer a rolagem pro grupo e depois começar a pintar pra não ficar travado até carregar os painéis do grupo selecionado
                    grupo.loading = false
                }, 10)
            }
        }
    })
    navegandoSideBar.value = false
}

const carregaGrupos = () => {
	$http.get("/formulario/GetGruposFormularios")
		.then(response => {
			data.value.dadosGrupos = response.data;
		})
		.catch(e => {
			$vistra.showMessage(!e.data.msgErro ? e : e.data.msgErro, "error");
		});
}
      
const carregaFormularios = () => {
	data.value.carregandoFormularios = true;
	$http.get("/formulario/GetFormularios")
	.then(response => {
		if (!response.data.msgErro) {
			data.value.dadosFormularios = response.data
		}
	})
	.catch(e => {
		$vistra.showMessage(!e.data.msgErro ? e : e.data.msgErro, "error");
	})
	.then(() => {                    
		data.value.carregandoFormularios = false;                   
	});
}

watch([categoriesRef, formulariosFiltrados, gruposFormulariosFiltrados, selected],() => {
  nextTick(() => showFormulariosOnScroll())
})
//#endregion

//#region A Ç Õ E S

// abre informações do painel
const onInfo = (props: CardProps) => {
  card.value = props;
  drawer.value?.toggle();
};

// marca/desmarca painel como favorito
const onFavorite = (idFormulario) => {
  let formulario = data.value.dadosFormularios.find(formulario => formulario.id == idFormulario);
  if(!formulario)
    return;

    formulario.favorito = !formulario.favorito
  if (formulario.favorito)
      $http.post(`/Favorito/${formulario.id}/${formulario.vistra4}`)
          .catch(e => {
              $vistra.showMessage(!e.data.msgErro ? e : e.data.msgErro, "error");
          });
  else
      $http.delete(`/Favorito/${formulario.id}/${formulario.vistra4}`)
          .catch(e => {
              $vistra.showMessage(!e.data.msgErro ? e : e.data.msgErro, "error");
          });
}
//#endregion

//#region L I F E C Y C L E   H O O K S

onMounted(async () => {
  await carregaGrupos();
	await carregaFormularios();
    showFormulariosOnScroll();
    formulariosContainer.value?.addEventListener('scroll', (e) => {
        showFormulariosOnScroll()
    })
})

onMounted(() => {
  const input = autocompleteRef.value?.$el.querySelector('input');
  input?.addEventListener('focus', () => {
    isFocused.value = true;
  });

  input?.addEventListener('blur', () => {
    isFocused.value = false;
  });
});

//#endregion
</script>

<template>
   <Panel :show="show" id="menu-formularios">
    <div
      class="sidebar flex flex-col w-56 bg-white dark:bg-gray-900 border-r border-solid border-r-gray-200 dark:border-r-gray-700"
      :class="{'h-screen' : $vistra.getDispositivo() != 'mobile'}"
    >
      <button
        type="button"
        class="flex gap-2 pt-7 pb-8 pl-8 text-sm text-gray-900 dark:text-white items-center border-b border-solid border-b-gray-200 dark:border-b-gray-700 transition-all duration-300 ease-in-out hover:!text-primary-500"
        @click="$emit('onClose')"
      >
        <img alt="" src="/assets/svgs/icon-close.svg" />
        {{ $vistra.globalize('title-formulario') }}
      </button>

      <div v-if="$vistra.getDispositivo() != 'mobile'" class="sidebar-items flex p-8 gap-6 flex-col overflow-y-auto" id="lista-grupos">
        <a
          v-for="({ id, nome, icon, imagem }, index) in gruposFormulariosFiltradosSideBar"
          :key="nome + id"
          type="button"
          class="sidebar-item flex gap-2 group items-center text-sm"
          @click="(e) => goToCategory(nome + id, index)"
          :class="
            selected === index
              ? 'is-selected text-primary-500'
              : 'text-gray-500 dark:text-gray-400'
          "
        >
          <span
            class="icon-group w-9 h-9 flex items-center justify-center rounded-full transition-all duration-300 ease-in-out"
            :class="
              selected === index
                ? 'bg-primary-500 !text-white group-hover:text-white'
                : 'bg-gray-50 dark:bg-gray-800 group-hover:text-primary-500'
            "
          >
            <img v-if="imagem" :src="`data:image/png;base64,${imagem}`" style="border-radius: 50%" />
            <component v-else :is="icon || IconProfiles" />
          </span>
          {{ nome }}
        </a>
      </div>
      <div v-else-if="$vistra.getDispositivo() == 'mobile'">
        <Drawer
          size="lg"
          ref="drawerMobile"
          :title="$vistra.globalize('title-formulario')"
          >
          <a
            :key="nome + id"
            type="button"
            v-for="({ id, nome, icon, imagem }, index) in gruposFormulariosFiltradosSideBar"
            class="sidebar-item flex pt-6 group items-center text-sm"
            @click="(e) => goToCategory(nome + id, index)"
            :class="
              selected === index
                ? 'is-selected text-primary-500'
                : 'text-gray-500 dark:text-gray-400'
            "
          >
            <span
              class="icon-group w-9 h-9 mr-2 flex items-center justify-center rounded-full transition-all duration-300 ease-in-out"
              :class="
                selected === index
                  ? 'bg-primary-500 !text-white group-hover:text-white'
                  : 'bg-gray-50 dark:bg-gray-800 group-hover:text-primary-500'
              "
            >
              <img v-if="imagem" :src="`data:image/png;base64,${imagem}`" style="border-radius: 50%;" />
              <component v-else :is="icon || IconProfiles" />
            </span>
            {{ nome }}
          </a>
        </Drawer>
      </div>
    </div>

    <div
      class="panel flex flex-col overflow-y-auto h-screen w-full"
      ref="formulariosContainer"
    >
      <div class="search w-[calc(100%-222px)] flex justify-between pt-8 px-10 pb-3 bg-gray-50 dark:bg-gray-900">
        <DxAutocomplete
          :top="8"
          :value="search"
          :class="$vistra.getDispositivo() != 'mobile' ? 'max-w-[362px]' : ''"
          :width="'100%'"
          :buttons="icons(['find'])"
          value-expr="label"
          :placeholder="$vistra.globalize('pesquisar-formulario')"
          :data-source="dsSearch"
          item-template="search"
          :search-timeout="400"
          :inputAttr="{id: 'inputPesquisa'}"
          :minSearchLength="3"
          :dropDownOptions="optionsDropdownSearch"
          :onValueChanged="onValueChanged"
          :onEnterKey="onValueChanged"
          valueChangeEvent="input change enter"
          ref="autocompleteRef"
        >
          <template #search="{ data }">
            <div :class="'flex text-sm items-center py-2 px-3' + $vistra.getDispositivo() == 'mobile' ? 'max-w-[250px]' : ''">
              <span class="max-w-full overflow-hidden text-ellipsis mr-2 text-gray-1000 dark:text-white">{{ data.label }}</span>
              <span class="py-1 px-2 text-xs ml-auto font-semibold border border-solid border-gray-300 dark:border-gray-500 rounded text-primary-500">{{ data.category }}</span>
            </div>
          </template>
        </DxAutocomplete>
        <DxButton
          v-if="$vistra.getDispositivo() == 'mobile'"
          id="btnNovoFormulario"
          :text="$vistra.globalize('btn-grupos-formularios')"
          style="width:100%"
          type="submit"
          :visible="!isFocused"
          @click="drawerMobile?.toggle()"
        />
      </div>

      <!--DESTAQUE (FIXO)-->
      <div id="#Destaques0" v-if="!filtro" :style="`margin-top: ${margemTop}px`">
        <!--RECENTES (FIXO)-->
        <div class="category"
        >
          <h2 class="title text-gray-900 dark:text-white px-10">
            {{ $vistra.globalize('title-recentes') }}
          </h2>
          <div class="formulario-cards mt-6 grid grid-cols-3 2xl:grid-cols-3 gap-5 px-10">
            <CardLoading
              v-if="data.carregandoFormularios && !filtered('recentes').length"
              v-for="(sk, indexF) in new Array(5)"
              :key="indexF"
              title=""
            />
            <Card
              v-else-if="filtered('recentes').length"
              v-for="(formulario, index) in filtered('recentes')"
              :key="formulario.id"
              :title="formulario.nome"
              :formulario="formulario"
              @oninfo="onInfo({ title: formulario.nome, favorite: formulario.favorito, descricao: formulario.descricao})"
              :favorite="formulario.favorito"
              @onfavorite="onFavorite"
              :usuario="usuario"
            />
            <h5 class="sem-dados" v-else>
              {{$vistra.globalize('nenhum-relatorio-recente')}}
            </h5>
          </div>
        </div>
        <!--RECENTES (FIXO)-->

        <!--FAVORITOS (FIXO)-->
        <div class="category"
        >
          <h2 class="title text-gray-900 dark:text-white px-10">
            {{$vistra.globalize('title-favoritos')}}
          </h2>
    
          <div class="formulario-cards mt-6 grid grid-cols-3 2xl:grid-cols-3 gap-5 px-10">
            <CardLoading 
              v-if="data.carregandoFormularios && !favoritosFiltrados.length"
              v-for="(sk, indexF) in new Array(5)"
              :key="indexF"
              title=""
            ></CardLoading>
            <Card
              v-else-if="favoritosFiltrados.length"
              v-for="(formulario, index) in favoritosFiltrados"
              :key="formulario.id"
              :title="formulario.nome"
              :formulario="formulario"
              @oninfo="onInfo({ title: formulario.nome, favorite: formulario.favorito, descricao: formulario.descricao})"
              :favorite="formulario.favorito"
              @onfavorite="onFavorite"
              :usuario="usuario"
            />
            <h5 class="sem-dados" v-else>
              {{$vistra.globalize('nenhum-relatorio-favorito')}}
            </h5>
          </div>
        </div>
        <!--RECENTES (FIXO)-->
      </div>
      
      <!--DESTAQUE (FIXO)-->
      <div class="category"
        :class="filtro ? 'pesquisando-paineis' : ''"
        v-for="grupo, idx in gruposFormulariosFiltrados"
        :key="grupo.nome + grupo.id"
        ref="categoriesRef"
        :id="`${grupo.nome + grupo.id}`"
        :data-idx="idx"
      >
        <h2 class="title text-gray-900 dark:text-white px-10">
          {{ grupo.nome }}
        </h2>
  
        <div class="formulario-cards mt-6 grid grid-cols-3 2xl:grid-cols-3 gap-5 px-10">
          <CardLoading class="loading rounded dx-theme-text-color loading-pulsante" 
	          v-if="data.carregandoFormularios"
	          v-for="(item, indexL) in filtered(grupo.nome)"
	          :key="indexL"
	          :title="item.nome"
          ></CardLoading>
          <Card
            v-for="(formulario, index) in filtered(grupo.nome)"
            :key="formulario.id"
            :title="formulario.nome"
            :formulario="formulario"
            :favorite="formulario.favorito"
            @onfavorite="onFavorite"
            :usuario="usuario"
          />
        </div>
      </div>
    </div>

    <Drawer ref="drawer"  :title="$vistra.globalize('btn-informacao')" size="lg">
      <div v-if="card" class="flex flex-col">
        <img v-if="card.preview" alt="" :src="card.preview" class="rounded-lg object-cover" style="max-height: 180px; max-width: 320px;"/>
        <i v-else alt="" class="fad fa-tree-map w-full rounded-lg object-cover" style="height: 222px; font-size: 222px; text-align: center;"></i>
        <div class="border-t border-solid border-t-gray-200 dark:border-t-gray-700 mt-6 pt-6" v-html="card.descricao" style="height: -webkit-fill-available;"></div>
      </div>
    </Drawer>
  </Panel>
</template>

<style lang="scss">
html {
  scroll-behavior: smooth;
}
.loading-pulsante {
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-name: loading-color;
    @apply bg-white dark:bg-gray-900;
}

@keyframes loading-color {
    30% {
        filter: brightness(80%)
    }
    80% {
        filter: brightness(80%)
    }
}
#menu-formularios {
  @import '@/styles/base.scss';

  .search {
    position: fixed;
    z-index: 1501;
  }

  #btnNovoFormulario {
    @apply bg-primary-500 px-3 hover:text-white #{!important}
  }
  .sem-dados {
    grid-column: 1 / 5;
  }
  .category {
    margin-bottom: 40px;
  }

  .category:last-child {
    margin-bottom: 100px;
  }

  .category.pesquisando-paineis:nth-of-type(2) {
    margin-top: 104px !important;
  }

  .icon-group {
    min-width: 36px;
  }

  .dx-texteditor {
    @apply shadow-none #{!important};
  }
  h2.title {
    @apply text-xl font-semibold #{!important};
  }
  h3 {
    @apply text-md font-medium;
  }

@media (max-width: 1490px) {
  .formulario-cards {
    @apply grid-cols-4 #{!important};
  }
}

@media (max-width: 1250px) {
  .formulario-cards {
    @apply grid-cols-3 #{!important};
  }
}

@media (max-width: 994px) {
  .sidebar {
    @apply w-full max-w-[11rem] #{!important};

    &-items {
      @apply p-5 #{!important};
    }
  }

  .panel {
    @apply w-[calc(100vw-11rem)];

    .search {
      z-index: 2;
      gap: 10px;
      @apply w-full max-w-full #{!important};

      .text {
        @apply overflow-hidden text-ellipsis mr-3 #{!important};
      }
    }

    &-cards {
      @apply grid-cols-2 #{!important};
    }
  }
}

@media (max-width: 700px) {
  .formulario-cards {
    @apply gap-2 #{!important};
  }
}

@media (max-width: 620px) {
  .formulario-cards {
    @apply grid-cols-1 #{!important};
  }
}

@media (max-width: 490px) {
  .sidebar {
    @apply max-w-full #{!important};

    & > button {
      @apply flex-row-reverse justify-between py-5 px-4 font-semibold text-xl #{!important};
    }

    &-items {
      @apply flex items-center flex-row overflow-x-auto py-6 px-4 #{!important};

      .sidebar-item {
        @apply py-2 px-4 rounded bg-gray-100 text-gray-400 dark:bg-gray-700 #{!important};

        &.is-selected {
          @apply bg-primary-100 text-primary-500 #{!important};

          span {
            @apply text-primary-500 #{!important};
          }
        }

        span {
          @apply text-gray-400 w-fit h-fit bg-transparent p-0 #{!important};
        }
      }
    }
  }

  .panel {
    .title {
      @apply text-lg mt-6 pt-6 border-t border-gray-200 dark:border-gray-800;
    }

    &-cards {
      @apply grid-cols-1 #{!important};
    }
  }
}

@media (max-width: 410px) {
  .panel {
    &-cards {
      @apply grid-cols-1 #{!important};
    }
  }
}
}

</style>
